<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <p class="text-gray-600 mb-4">
    <span *ngIf="data.mode === 'offboard'">
      Offboard <strong>{{ data.vendorName }}</strong>? They will lose access and be removed from active bidding.
    </span>
    <span *ngIf="data.mode === 'reinstate'">
      Reinstate <strong>{{ data.vendorName }}</strong>? Their account will be reactivated.
    </span>
    <span *ngIf="data.mode === 'suspend'">
      Suspend availability for <strong>{{ data.vendorName }}</strong>? Login stays active; they cannot be assigned to new work until restored.
    </span>
    <span *ngIf="data.mode === 'unsuspend'">
      Restore availability for <strong>{{ data.vendorName }}</strong>? Login was never disabled.
    </span>
  </p>

  <form [formGroup]="form" class="flex flex-col gap-3">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ reasonLabel }}</mat-label>
      <textarea matInput rows="3" formControlName="reason"></textarea>
      <mat-error *ngIf="form.get('reason')?.hasError('required')">Reason is required</mat-error>
    </mat-form-field>

    <mat-checkbox *ngIf="showForce" formControlName="force" color="warn">
      Force offboard despite open invoices (admin override)
    </mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button
    mat-raised-button
    [color]="confirmColor"
    (click)="confirm()"
    [disabled]="form.invalid"
  >
    {{ confirmLabel }}
  </button>
</mat-dialog-actions>
